import { AddressActionType } from "./action-type";
import { setGlobalLoader } from '../../context/LoaderContext'
import { Alert } from "../../util/Alert";

const initialState = {
    address: {
        "cep": "",
        "logradouro": "",
        "complemento": "",
        "unidade": "",
        "bairro": "",
        "localidade": "",
        "uf": "",
        "estado": "",
        "regiao": "",
        "ibge": "",
        "gia": "",
        "ddd": "",
        "siafi": ""
    }
}

export const addressReducer = (state = initialState, action) => {
    const zipCode = action.payload;
    const callBack = action.callBack;

    if (action.type === AddressActionType.ZIP_CODE_SEARCH) {
        setGlobalLoader(true);
        fetch(`https://viacep.com.br/ws/${zipCode}/json/`)
            .then(async response => {
                var data = await response.json();
                callBack(data);
                return { ...state, address: data }
            })
            .catch(err => {
                Alert('Houve um erro ao buscar o endereço', '', false)
            }).finally(() => {
                setGlobalLoader(false);
            })
    }

    return state;
}